import { OperationTypeNode } from "graphql";
const MUTATION_REQUIRES_POST_REASON = "Mutations can only be sent via POST";
function resolveActiveOperation(operations, operationName) {
  if (!(operations == null ? void 0 : operations.length)) {
    return void 0;
  }
  if (operations.length === 1) {
    return operations[0];
  }
  return operations.find((op) => {
    var _a;
    return ((_a = op.name) == null ? void 0 : _a.value) === operationName;
  });
}
function getRunBlockReason(method, operation) {
  const effectiveMethod = method ?? "POST";
  if (effectiveMethod !== "POST" && (operation == null ? void 0 : operation.operation) === OperationTypeNode.MUTATION) {
    return MUTATION_REQUIRES_POST_REASON;
  }
  return null;
}
export {
  MUTATION_REQUIRES_POST_REASON,
  getRunBlockReason,
  resolveActiveOperation
};
//# sourceMappingURL=run-block.js.map
